// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"95fbdf96","453":"8e9e3179","987":"c7ade641"}[chunkId] + ".chunk.js";
};